import { panelRoutesConfig } from "./panel/panelRoutesConfig";
import { errorRoutesConfig } from "./error/errorRoutesConfig";
import { healthRoutesConfig } from "./health/healthRoutesConfig";

interface IRoute {
  auth: string[];
  exact: boolean;
  path: string;
  component:
    | React.LazyExoticComponent<(props: any) => JSX.Element>
    | React.LazyExoticComponent<React.MemoExoticComponent<() => JSX.Element>>;
  title?: string;
  description?: string;
}

interface IRoutesConfig {
  auth: string[];
  path: string;
  layout: React.LazyExoticComponent<(props: any) => JSX.Element>;
  routes: IRoute[];
}

type IGlobalConfig = IRoute[];

const appRoutesConfig: IRoutesConfig[] = [panelRoutesConfig];
const appGlobalRoutes: IGlobalConfig = [
  ...errorRoutesConfig,
  ...healthRoutesConfig,
];

export { appRoutesConfig, appGlobalRoutes };
export type { IRoutesConfig, IGlobalConfig };
